/**
 *街道/社区配置
 */
import request from '@/utils/request';
// import { getToken } from '@/utils/auth';
// import ENVIRONMENT from '@/utils/environment';

/**
 * 分页查询社区列表
 */
export function get_community_pagelist(options) {
  return request({
    url: `/op/street/community_pagelist`,
    method: 'get',
    params: options
  });
}
/**
 * 修改社区状态
 */
export function update_comm_status(status, id) {
  return request({
    url: `/op/street/updateCommStatus/${id}`,
    method: 'post',
    data: status
  });
}
/**
 * 分页查询社区列表
 */
export function get_street_pagelist(options) {
  return request({
    url: `/op/street/`,
    method: 'get',
    params: options
  });
}
/**
 * 修改街道状态
 */
export function update_Status(status, id) {
  return request({
    url: `/op/street/updateStatus/${id}`,
    method: 'post',
    data: status
  });
}
/**
 * 批量删除
 */
export function batch_delete(data) {
  return request({
    url: `/op/street/batchDelete`,
    method: 'post',
    data: data
  });
}
/**
 * 批量添加
 */
export function batch_add(id, data) {
  return request({
    url: `/op/street/bathchAdd/${id}`,
    method: 'post',
    data: data
  });
}
/**
 * 批量查询街道列表
 */
export function getStreets(data) {
  return request({
    url: `/op/street/getStreets`,
    method: 'get',
    params: data
  });
}
/**
 * 查询所属社区下拉框
 */
export function getCommunitys(data) {
  return request({
    url: `/op/street/getCommunitys`,
    method: 'get',
    params: data
  });
}
